import React from 'react';
import Slider from 'react-slick';

const fallbackSlides = [
  {
    title: 'Get Special Offer',
    subtitle: 'Up to 40% off',
    badge: 'Limited time',
    cta: 'Claim',
    image: require('../../assets/img/products/papad1.png'),
  },
  {
    title: 'Crunchy Papad Packs',
    subtitle: 'Save more on combos',
    badge: 'Fresh drops',
    cta: 'Explore',
    image: require('../../assets/img/products/papad2.png'),
  },
  {
    title: 'Rice Papad Specials',
    subtitle: 'Weekend kitchen picks',
    badge: 'Chef choice',
    cta: 'Order now',
    image: require('../../assets/img/products/papad3.png'),
  },
  {
    title: 'Tomato Papad Delights',
    subtitle: 'Spicy and crispy favorites',
    badge: 'Best value',
    cta: 'Buy now',
    image: require('../../assets/img/products/papad4.jpg'),
  },
];

export default function MainSlider({ banners = [], onSeeAll }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const slides = banners.length ? banners : fallbackSlides;

  return (
    <Slider {...settings}>
      {slides.map((slide, index) => (
        <div key={slide.banner_id || slide.title || index} className='slide-container'>
          <div className='slide-item'>
            <div className='slide-text'>
              <span className='slide-badge'>{slide.badge || 'Special for you'}</span>
              <h3>{slide.title || 'Fresh picks for today'}</h3>
              <p>{slide.subtitle || 'Shop the latest arrivals'}</p>
              <button type='button' className='slide-cta'>
                {slide.cta || 'Claim'}
              </button>
            </div>
            <img
              src={slide.image}
              alt={slide.title || 'Banner'}
              style={{ width: '132px', height: '132px', objectFit: 'contain' }}
            />
          </div>
        </div>
      ))}
    </Slider>
  );
}
